import { PASSCODE_LIST_TYPE, PasscodeList, PasscodeListMember, RegFieldsEnum } from '@/types/registration.types';
import TableData from '@layouts/layout-table/layout-table-data';
import TableRow from '@layouts/layout-table/layout-table-row';
import Checkbox from '@ui/checkbox/checkbox';
import { MagicLinkStatus } from '../../types';
import OptionalComponent from '@ui/optional-component/optional-component';
import { ICONS } from '@ui/icons/types';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';
import Text from '@/general-ui/text/text/text';
import ProfileTableCell from '@/micros/edit-project/grid-areas/main/audiences/components/profile-table-cell';
import toastTrigger from '@ui/toast/toast-trigger';
import Container from '@ui/container/container';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import { listMemberName } from '../../utils';
import { EToastTypes } from '@ui/toast/toast.types';

type PasscodeListMemberTableRowProps = {
  passcodeListMember: PasscodeListMember;
  passcodeList: PasscodeList;
  isSelected?: boolean;
  setIsSelected: () => void;
};

const PasscodeListMemberTableRow = ({
  passcodeListMember,
  passcodeList,
  isSelected = false,
  setIsSelected,
}: PasscodeListMemberTableRowProps) => {
  const handleCheckboxChange = () => {
    if (setIsSelected) {
      setIsSelected();
    }
  };

  const copyToClipboard = () => {
    if (passcodeListMember.magic_link?.magic_link?.length) {
      navigator.clipboard.writeText(passcodeListMember.magic_link?.magic_link || '');
      toastTrigger('Login link copied to clipboard', {
        type: EToastTypes.success,
        autoClose: 10000,
      });
    } else {
      toastTrigger('There is no login link to copy', {
        type: EToastTypes.error,
        autoClose: 10000,
      });
    }
  };

  return (
    <TableRow key={passcodeListMember.passcode_list_member}>
      <TableData>
        <Checkbox
          checked={isSelected}
          onChange={handleCheckboxChange}
          value={passcodeListMember.passcode_list_member}
          selectedIconName={ICONS.ROUND_CHECKBOX_SELECTED}
          unselectedIconName={ICONS.ROUND_CHECKBOX_UNSELECTED}
        />
      </TableData>
      <TableData width={170}>
        <Container className="" background="transparent">
          <TooltipPortal
            tooltipContent={
              <>
                <Text color="var(--gray-true-dark-100)">{listMemberName(passcodeListMember)}</Text>
                <Text color="var(--gray-true-dark-100)">{passcodeListMember.email}</Text>
              </>
            }
          >
            <ProfileTableCell
              firstName={passcodeListMember?.imported_profile?.[RegFieldsEnum.first_name]}
              lastName={passcodeListMember?.imported_profile?.[RegFieldsEnum.last_name]}
              email={passcodeListMember?.email}
              avatar={passcodeListMember?.avatar}
            />
          </TooltipPortal>
        </Container>
      </TableData>

      <OptionalComponent
        display={[PASSCODE_LIST_TYPE.PASSCODES_ONLY, PASSCODE_LIST_TYPE.EMAILS_AND_PASSCODES].includes(
          passcodeList.type
        )}
      >
        <TableData>{passcodeListMember.passcode || 'NOT SET'}</TableData>
      </OptionalComponent>
      <OptionalComponent
        display={[
          PASSCODE_LIST_TYPE.EMAILS_ONLY,
          PASSCODE_LIST_TYPE.PASSCODES_ONLY,
          PASSCODE_LIST_TYPE.EMAILS_AND_PASSCODES,
        ].includes(passcodeList.type)}
      >
        <TableData>{passcodeListMember.uses || 0}</TableData>
      </OptionalComponent>
      <TableData>{passcodeListMember.registrations_count || 0}</TableData>
      <TableData>{passcodeListMember.attended_count || 0}</TableData>
      <OptionalComponent display={[PASSCODE_LIST_TYPE.MAGIC_LINKS].includes(passcodeList.type)}>
        <TableData>
          {passcodeListMember.magic_link?.status ? MagicLinkStatus[passcodeListMember.magic_link?.status] : 'Unknown'}
        </TableData>
      </OptionalComponent>
      <OptionalComponent display={[PASSCODE_LIST_TYPE.MAGIC_LINKS_REGISTRATION].includes(passcodeList.type)}>
        <TableData>{passcodeListMember.magic_link?.is_sent ? 'Invite sent' : 'Not sent'}</TableData>
      </OptionalComponent>
      <OptionalComponent
        display={[PASSCODE_LIST_TYPE.MAGIC_LINKS, PASSCODE_LIST_TYPE.MAGIC_LINKS_REGISTRATION].includes(
          passcodeList.type
        )}
      >
        <TableData>
          <Button className="flex fd-row ai-center gap-4" onClick={copyToClipboard} design="LocalBttnSec">
            <Icon name={ICONS.COPY} size={12} />
            <Text fontSize="12px">Copy</Text>
          </Button>
        </TableData>
      </OptionalComponent>
    </TableRow>
  );
};
export default PasscodeListMemberTableRow;
